import AppConfig from 'appConfig';
import AbstractFetch from './AbstractFetch';

class EventTypeFetch extends AbstractFetch {
  static getAll(criterias = {}) {
    return AbstractFetch.fetch(
      AppConfig.apiUrl + '/events/event-types/search',
      {
        method: 'POST',
        cache: 'no-cache',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        },
        body: JSON.stringify(criterias),
      },
      true
    )
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.log('Error fetch alert types:', e);
        return JSON.stringify([]);
      });
  }
}

export default EventTypeFetch;
